"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "policy-top-margin"
};
const _hoisted_2 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--mars_first')
};
const _hoisted_3 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--scientists')
};
const _hoisted_4 = {
    key: 2,
    class: "policy-top-margin"
};
const _hoisted_5 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--unity')
};
const _hoisted_6 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--kelvinists')
};
const _hoisted_7 = {
    key: 4,
    class: "policy-top-margin"
};
const _hoisted_8 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--reds')
};
const _hoisted_9 = {
    class: (0, vue_1.normalizeClass)('party-badge party-badge--greens')
};
const _hoisted_10 = { key: 6 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.id === 'mp01')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_2, null, 512), [
                    [_directive_i18n]
                ]),
                _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "tile empty-tile-small" }, null, -1)),
                _cache[1] || (_cache[1] = (0, vue_1.createTextVNode)(" : ", -1)),
                _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("span", { class: "steel resource" }, null, -1))
            ]))
            : (_ctx.id === 'sp01')
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("span", _hoisted_3, null, 512), [
                        [_directive_i18n]
                    ]),
                    _cache[3] || (_cache[3] = (0, vue_1.createStaticVNode)("<span class=\"money resource\">10</span><span class=\"red-arrow\"></span><span class=\"card card-with-border resource party-resource\"></span><span class=\"card card-with-border resource party-resource\"></span><span class=\"card card-with-border resource party-resource\"></span>", 5))
                ], 64))
                : (_ctx.id === 'up01')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_5, null, 512), [
                            [_directive_i18n]
                        ]),
                        _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("div", { class: "resource titanium" }, null, -1)),
                        _cache[5] || (_cache[5] = (0, vue_1.createTextVNode)(" : + ", -1)),
                        _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("div", { class: "resource money" }, "1", -1))
                    ]))
                    : (_ctx.id === 'kp01')
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("span", _hoisted_6, null, 512), [
                                [_directive_i18n]
                            ]),
                            _cache[7] || (_cache[7] = (0, vue_1.createStaticVNode)("<span class=\"money resource\">10</span><span class=\"red-arrow-infinity\"></span><div class=\"production-box production-box-size2\"><div class=\"energy production\"></div><div class=\"heat production\"></div></div>", 3))
                        ], 64))
                        : (_ctx.id === 'rp01')
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_8, null, 512), [
                                    [_directive_i18n]
                                ]),
                                _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("div", { class: "rating tile" }, null, -1)),
                                _cache[9] || (_cache[9] = (0, vue_1.createTextVNode)(" : ", -1)),
                                _cache[10] || (_cache[10] = (0, vue_1.createElementVNode)("div", { class: "resource money" }, "-3", -1))
                            ]))
                            : (_ctx.id === 'gp01')
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 5 }, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_9, null, 512), [
                                        [_directive_i18n]
                                    ]),
                                    _cache[11] || (_cache[11] = (0, vue_1.createElementVNode)("div", { class: "tile greenery-tile" }, null, -1)),
                                    _cache[12] || (_cache[12] = (0, vue_1.createTextVNode)(" : ", -1)),
                                    _cache[13] || (_cache[13] = (0, vue_1.createElementVNode)("div", { class: "resource money" }, "4", -1))
                                ], 64))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, "Unknown agenda ID " + (0, vue_1.toDisplayString)(_ctx.id), 1))
    ]));
}
